import React, { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '../../../hooks/react-redux';
import { SaveReportTemplateModal } from '../../shared/report/SaveReportTemplateModal';
import { getReportTemplateDescription, getReportTemplateName, getSaveTemplateModalOpen, getSelectedTemplateId, saveReportTemplateStarted, toggleSaveTemplateModalOpen, updateReportTemplateValue } from './store';

export const SaveTemplateModal: React.FC = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(getSaveTemplateModalOpen);
    const name = useAppSelector(getReportTemplateName);
    const description = useAppSelector(getReportTemplateDescription);
    const selectedTemplateId = useAppSelector(getSelectedTemplateId);

    const closeModal = () => dispatch(toggleSaveTemplateModalOpen(false));
    const updateName = useCallback((value: string) => dispatch(updateReportTemplateValue('templateName', value)), [dispatch]);
    const updateDescription = useCallback((value: string) => dispatch(updateReportTemplateValue('templateDescription', value)), [dispatch]);
    const saveTemplate = (saveAs: boolean) => dispatch(saveReportTemplateStarted(saveAs));

    return (
        <SaveReportTemplateModal
            isOpen={isOpen}
            closeModal={closeModal}
            save={saveTemplate}
            name={name}
            description={description}
            updateName={updateName}
            updateDescription={updateDescription}
            templateId={selectedTemplateId}
            testId='opinion'
        />
    );
};
